var exports = {
  "kL": "CompactVoiceCallView.module__container___bkRkSl",
  "gw": "CompactVoiceCallView.module__containerNoHeader___bkRkSl",
  "lf": "CompactVoiceCallView.module__containerReserveHeaderChrome___bkRkSl",
  "L7": "CompactVoiceCallView.module__containerNoControlBar___bkRkSl",
  "ap": "CompactVoiceCallView.module__containerFillHeight___bkRkSl",
  "tZ": "CompactVoiceCallView.module__contentArea___bkRkSl",
  "$7": "CompactVoiceCallView.module__contentAreaAudioOnly___bkRkSl",
  "OZ": "CompactVoiceCallView.module__audioAvatarLayout___bkRkSl",
  "a3": "CompactVoiceCallView.module__audioAvatarLayoutInner___bkRkSl",
  "d6": "CompactVoiceCallView.module__audioAvatarLayoutFullBleed___bkRkSl",
  "nd": "CompactVoiceCallView.module__audioAvatarLayoutInnerFullBleed___bkRkSl",
  "Gq": "CompactVoiceCallView.module__audioAvatarList___bkRkSl",
  "D9": "CompactVoiceCallView.module__layoutHost___bkRkSl",
  "pl": "CompactVoiceCallView.module__layoutHostFullHeight___bkRkSl",
  "DO": "CompactVoiceCallView.module__layoutHostFullHeightGrid___bkRkSl",
  "vR": "CompactVoiceCallView.module__layoutHostFullHeightFocus___bkRkSl",
  "_t": "CompactVoiceCallView.module__controlBarSection___bkRkSl",
  "Vw": "CompactVoiceCallView.module__controlBarInner___bkRkSl",
  "AD": "CompactVoiceCallView.module__fullscreenButtonWrap___bkRkSl",
  "I": "CompactVoiceCallView.module__heightToggleButtonWrap___bkRkSl",
  "Ip": "CompactVoiceCallView.module__heightToggleButtonShell___bkRkSl",
  "x8": "CompactVoiceCallView.module__heightTogglePill___bkRkSl",
  "_A": "CompactVoiceCallView.module__heightTogglePillIcon___bkRkSl",
  "oP": "CompactVoiceCallView.module__heightToggleUnreadBadge___bkRkSl",
  "Di": "CompactVoiceCallView.module__resizeHandle___bkRkSl",
  "YC": "CompactVoiceCallView.module__resizePill___bkRkSl",
  "$I": "CompactVoiceCallView.module__containerResizing___bkRkSl",
};

module.exports = exports;
